import { type ClassValue, cn, tv } from '@eluve/components';

import { type FloatingActionButtonTone } from './FloatingActionButton';

const floatingActionDividerStyles = tv({
  base: cn(
    'shrink-0',
    'data-[orientation=horizontal]:h-4 data-[orientation=horizontal]:w-px',
    'data-[orientation=vertical]:h-px data-[orientation=vertical]:w-[calc(100%-2rem)]',
  ),
  variants: {
    tone: {
      dark: 'bg-white/20',
      light: 'bg-black/15',
    },
  },
  defaultVariants: {
    tone: 'dark',
  },
});

type FloatingActionDividerProps = {
  orientation?: 'horizontal' | 'vertical';
  tone?: FloatingActionButtonTone;
  className?: ClassValue;
};

export const FloatingActionDivider = ({
  orientation = 'horizontal',
  tone,
  className,
}: FloatingActionDividerProps) => (
  <div
    data-orientation={orientation}
    className={cn(floatingActionDividerStyles({ tone }), className)}
  />
);
